import type { APPLICANT_ATTRIBUTION } from 'cpool-constants';
import { REAL_ESTATE_USAGES } from 'cpool-constants';
import { createId } from 'cpool-utils';

export const getRealEstateDefaultValues = (attribution: APPLICANT_ATTRIBUTION) => ({
    baubeschreibung: null,
    baufinanzierungsrate: null,
    bezeichnung: null,
    darlehen: [],
    gehoertZuAntragsteller: attribution,
    id: createId(),
    immobilienart: null,
    mieteinnahmenKaltMonatlich: null,
    mieteinnahmenWarmMonatlich: null,
    nebenkostenMonatlich: null,
    nutzungsart: REAL_ESTATE_USAGES.VERMIETET,
    vermieteteWohnflaeche: null,
    wert: null,
    wohnflaeche: null,
});
